import { Win, WinCalculated } from "../../interfaces/dtos/win";
import { getOverround, getWinDerivCommonCalculated } from "../common/commonCalculated";

export const getWinCalculated = (win: Win): WinCalculated => {
    return {
        ...getWinDerivCommonCalculated(win),
        overroundTotal: calculateOverroundTotal(win)
    }
}

const calculateOverroundTotal = (win: Win) => {
    if (!win.selections) { return '0%'; }
    // The total percentage is all the individual calculated prices added up
    const total = win.selections.reduce((partialSum, a) => partialSum + getOverround(a), 0);
    return `${Number(total.toFixed(2))}%`;
}
